angular.module('impactx.basket').directive('appBasketItem', function ()
{
    return {
        scope: {
            basketItem : '=',
            selectedBasketItems: '=',
            selectedBasketSupplier: '=',
            trns : '=',
            showControl: '=',
            showAddresses: '=',
            showComments: '=',
            form: "=",
            markAsChanged: "&",
            showGross: "=",
            showNet: "=",
            showCatalogNet: "=",
            readOnly: "=",
            getBasket: "&",
            saveBasket: "&",
            updateFileSize: "&",
            rejectItem: "&",
            changePayerCompany: "&",
            prgSelected: "&",
            unbundleItem: "&",
            changeAat: "&",
            requireAat: "=",
            requireCtrl: "&",
            isTemplate: "=",
            ignoreAccountingRequired: "=",
            ignoreMaterialGroupRequired: "=",
            showBasketItemOfferDialog: "&",
            deleteBasketItemGroup: "&",
            disableSendDistribListCheckbox: "=",
            openAddressDialog: "&",
            removeAddresses: "&",
            openControlDialog: "&",
            removeControls: "&",
            parentControlLabels: "=",
            basketControlLabels: "=",
            openDatesDialog: "&",
            removeDates: "&",
            useBudgetProjectPreference: "=",
            useBudgetCostCenterPreference: "=",
            anySupplierHasAltDeliveryDates: "=",
            minimized : "=",
        },
        restrict: 'E',
        templateUrl: 'modules/basket/templates/basketitem.html',
        transclude: true
    };
});